import { render, staticRenderFns } from "./IconAllow.vue?vue&type=template&id=5b7d70f6&"
import script from "./IconAllow.vue?vue&type=script&lang=js&"
export * from "./IconAllow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports